// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.settingBox[data-v-4883c3fc] {\r\n    width: 100%;\r\n    padding: 30px 0px!important;\r\n    border: 1px solid #f4f4f4;\n}\r\n", ""]);
// Exports
module.exports = exports;
